import { render, staticRenderFns } from "./ProductInventoryRow.vue?vue&type=template&id=f10603a8&scoped=true&"
import script from "./ProductInventoryRow.vue?vue&type=script&lang=js&"
export * from "./ProductInventoryRow.vue?vue&type=script&lang=js&"
import style0 from "./ProductInventoryRow.vue?vue&type=style&index=0&id=f10603a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10603a8",
  null
  
)

export default component.exports